import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "PageNotFoundstyles__Container",
  componentId: "sc-5dlk60-0"
})(["margin:0 auto;align-items:center;justify-content:center;padding:15px;min-height:500px;text-align:center;"]);
var ButtonsContainer = styled.div.withConfig({
  displayName: "PageNotFoundstyles__ButtonsContainer",
  componentId: "sc-5dlk60-1"
})(["width:300px;margin:60px auto 0;button:first-of-type{margin-top:30px;}"]);
export { Container, ButtonsContainer };